import Ajax from '../ajax'

export default {
  addresses: () => Ajax('get', 'front/address/list'),
  createAddress: (data) => Ajax('post', 'front/address', data),
  updateAddress: (id, data) => Ajax('put', `front/address/${id}`, data),
  deleteAddress: (data) => Ajax('delete', `front/address`, data, 'params'),
  setDefaultAddress: (id) => Ajax('put', `front/address/setDefault/${id}`)
}
